<template>
    <div class="headers" :style="`background-image:url('${baseUrl}img/${img}.jpg')`">
        <div class="headerText">{{title.toUpperCase()}}</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
        }
    },
    props:[
        'img','title'
    ]
}
</script>
<style lang="less">
.headers{
    width: 100%;
    position: relative;
    height: 450px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .headerText{
        position: absolute;
        left: 21%;
        top: 50%;
        transform: translate(0,-40%);
        color: #fff;
        font-size: 2rem;
        font-weight: bold;
        letter-spacing: 0.15rem;
    }
}
</style>

